import { caretVariables as cjsCaretVariables, contextColors as cjsContextColors} from './cssVariables.cjs.css'

export const caretVariables = cjsCaretVariables
export const contextColors = cjsContextColors